// Who a task is from and who it is for, as every task list shows them (the /tasks page, the
// homepage widget, the customer page's tab, the task modal): "מאת X · מוקצה ל Y".
//
// A task carries createdBy / assignedTo ({ id, name, type } - the server cuts the users down to
// that) and source, which says who made it when no user did: an automation's "create task"
// action, the event class's milestones, or a copy of a recurring task. The old rows have none of
// it and show nothing.

export const TASK_SOURCE_LABELS = {
    automation: 'אוטומציה',
    milestone: 'אבני דרך',
    recurrence: 'משימה חוזרת',
    check: "צ'ק חוזר"
};

// the owner's tag in the assignee lists
export function userTypeTag(user) {
    return user && user.type == 5 ? 'מנהל' : '';
}

// a user's name with the owner's tag: "דנה (מנהל)"
export function userLabel(user) {
    if (!user || !user.name)
        return '';
    let tag = userTypeTag(user);
    return tag ? user.name + ' (' + tag + ')' : user.name;
}

// true when the system made the task, not a user (the label then says which part of it)
export function isSystemTask(task) {
    return !!task && !(task.createdBy && task.createdBy.name) && !!(task.source || task.wasMilestone);
}

// "מאת": the creator's name, or what made the task; '' for a row that says nothing
export function taskCreatorLabel(task) {

    if (!task)
        return '';

    if (task.createdBy && task.createdBy.name)
        return task.createdBy.name;

    if (task.source && TASK_SOURCE_LABELS[task.source])
        return TASK_SOURCE_LABELS[task.source];

    if (task.wasMilestone)
        return TASK_SOURCE_LABELS.milestone;

    return '';
}

// "מוקצה ל": the assignee's name, '' when the task is nobody's in particular
export function taskAssigneeLabel(task) {
    return task && task.assignedTo && task.assignedTo.name ? task.assignedTo.name : '';
}

// the lists' line under a task's name: "מאת דנה · מוקצה ליוסי" ('' when there is nothing to say)
export function taskPeopleLine(task) {

    let creator = taskCreatorLabel(task);
    let assignee = taskAssigneeLabel(task);

    return [creator ? 'מאת ' + creator : '', assignee ? 'מוקצה ל' + assignee : ''].filter(Boolean).join(' · ');
}

// true when the task is one of a chain (a follow-up, or followed by one - the lists' link icon
// only knows the first from its followUpOfId / chainId; the first task of a chain learns it
// from the chain itself, which the modal loads)
export function isChainedTask(task) {
    return !!task && !!(task.followUpOfId || task.chainId);
}
